import Store from "./components/Store.vue";
import ShoppingCart from "./components/ShoppingCart.vue";
import ProductDetails from "./components/ProductDetails.vue";
import Login from "./components/auth/login.vue";
import Register from "./components/auth/register.vue";
import Account from "./components/auth/accountdata.vue";
import Admin from "./components/Admin.vue";
import mobileauth from "./components/mobileauth.vue";

export const routes = [
  { path: "/", component: Store, name: "mainpage" },
  { path: "/product/:id", component: ProductDetails, name: "product" },
  { path: "/cart", component: ShoppingCart, name: "shoppingcart" },
  { path: "/mobile-view-auth", component: mobileauth, name: "mobileauth" },
  {
    path: "/adminportal",
    component: Admin,
    name: "admin",
    meta: {
      authRequired: true
    }
  },
  { path: "/login", component: Login, name: "login", onlyGuest: true },
  { path: "/data", component: Account, name: "Account", onlyGuest: true },
  { path: "/register", component: Register, name: "register", onlyGuest: true },
  { path: "*", redirect: "/" },
];
